import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeComponent from "../components/Home/HomeComponent.jsx";
import AboutComponent from "../components/AboutMe/AboutComponent.jsx";
import SkillsComponent from "../components/Skills/SkillsComponent.jsx";
import PortfolioComponent from "../components/Portfolio/PortfolioComponent.jsx";
import ContactComponent from "../components/Contact/ContactComponent.jsx";
import PrivacyPolicyComponent from "../components/PrivacyPolicy/PrivacyPolicyComponent.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent />} />
      <Route path="/about" element={<AboutComponent />} />
      <Route path="/skills" element={<SkillsComponent />} />
      <Route path="/portfolio" element={<PortfolioComponent />} />
      <Route path="/contact" element={<ContactComponent />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyComponent />} />
    </Routes>
  );
};

export default AppRoutes;